<template>
    <div>
        <div class="content">
            <h1 class="text-center">KITTIES</h1>

            <div>
                <label>Category: </label>
                <select @change="toFirstPage()" v-model="params.category_ids" class="form-control border-pink">
                    <option value="" selected>All</option>
                    <option v-for="category in categories" :key="category.id" :value="category.id">{{ category.name }}</option>
                </select>
            </div>

            <div>
                <label>Breed: </label>
                <select @change="params.category_ids=''; toFirstPage();" v-model="selectedBreed" class="form-control border-pink">
                    <option value="null" selected>All</option>
                    <option v-for="(breed, index) in breeds" :key="breed.id" :value="index">{{ breed.name }}</option>
                </select>
            </div>

            <div v-if="selectedBreed !== null" class="row justify-content-center my-1">
                <button class="btn btn-secondary" data-toggle="collapse" data-target="#breedInfo">
                    {{ breeds[selectedBreed].name }}
                </button>
                <div class="collapse text-center" id="breedInfo">
                        {{ breeds[selectedBreed].description }}
                </div>
            </div>

            <hr>

            <h1 class="cursor-pointer text-center my-2">
                <i class="fas fa-arrow-alt-circle-left mx-2 text-pink" v-if="params.page > 1" @click="() => { getImagesByPage(--params.page) }"></i>
                <i class="fas fa-arrow-alt-circle-right mx-2 text-pink" @click="() => { getImagesByPage(++params.page) }"></i>
            </h1>
            
            <div v-if="catImgages.length > 0">
                <div v-for="img in catImgages" :key="img.id" width="50">
                    <img :src="img.url" class="m-1" />
                </div>
            </div>
            <h1 class="cursor-pointer text-center my-2">
                <i class="fas fa-arrow-alt-circle-left mx-2 text-pink" v-if="params.page > 1" @click="() => { getImagesByPage(--params.page) }"></i>
                <i class="fas fa-arrow-alt-circle-right mx-2 text-pink" @click="() => { getImagesByPage(++params.page) }"></i>
            </h1>

            <h3 class="text-center" v-if="hasNoData">No result.</h3>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return {
            params:{
                limit: 5,
                order: 'asc',
                page: 1,
                category_ids: '',
                breed_ids: '',
            },
            catImgages: [],
            categories: [],
            breeds: [],
            selectedBreed: null,
            hasNoData: false,
        }
    },
    methods:{
        getImages(){
            this.catImgages = [];
            this.hasNoData = false;
            this.$loading()
            this.$axios.get('https://api.thecatapi.com/v1/images/search', { params: this.params })
                .then((response) => {
                    this.catImgages = response.data;
                    if(this.catImgages.length == 0) this.hasNoData = true;
                })
                .catch((error) => {
                    console.log(error)
                })
                .finally(() => {
                    this.$loading().close()
                })
        },
        getImagesByPage(page){
            this.params.page = page;
            this.getImages();
        },
        getCategories(){
            this.$axios.get('https://api.thecatapi.com/v1/categories')
                .then((response) => {
                    this.categories = response.data;
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        getBreeds(){
            this.$axios.get('https://api.thecatapi.com/v1/breeds')
                .then((response) => {
                    this.breeds = response.data;
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        toFirstPage(){
            this.params.page = 1;
            this.params.breed_ids = this.selectedBreed ? this.breeds[this.selectedBreed].id : '';
            this.getImages();
        },
    },
    created(){
        this.getImagesByPage(this.params.page);
        this.getCategories();
        this.getBreeds();
    },
}
</script>

<style scoped>
    .content{
        margin: 2% 20%;
    }
    .floating{
        position: fixed;
        top: 50%;
        color:aqua;
        background: transparent;
        border: 1px solid;
        border-radius: 1000px;
    }
    .floating-left{
        left: 20%;
    }
    .floating-right{
        right: 20%;
    }
    img{
        width: 100%;
        border-radius: 20px;
    }
    .card-body{
        background: white;
        width: 50%;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    .border-pink{
        border: 1px solid lightpink;
    }
    .text-pink{
        color: lightpink;
    }
</style>